"use client";

import React from "react";
import Header from "../global/partials/Header";
import Footer from "../global/partials/Footer";
import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";
import HeroSection from "../pageComponents/manifesto/HeroSection";
import LetterSection from "../pageComponents/manifesto/LetterSection";
import ChaptersSection from "../pageComponents/manifesto/ChaptersSection";
import ConclusionSection from "../pageComponents/manifesto/ConclusionSection";
import HeaderV2 from "../global/partials/HeaderV2";

export default function PageManifestoJSX({
  data,
}: {
  data: PageManifestoSchema;
}) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={"main"} // showBorder
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <LetterSection data={data} />
      <ChaptersSection data={data} />
      <ConclusionSection data={data} />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
